import 'react-international-phone/style.css'
import { PhoneInput } from 'react-international-phone'

import { PhoneFieldWrapper } from './styled'
import { PhoneFieldProps } from './types'

/**
 * International phone input with a country-flag selector, dial code, and
 * format-as-you-type. Defaults to Canada and returns the full phone string
 * (dial code included) via `onChange`. Wraps `react-international-phone`,
 * themed to the QuickPass palette.
 *
 * @param {PhoneFieldProps} props
 * @returns {JSX.Element}
 */
const PhoneField = ({
  value,
  onChange,
  inputId,
  disabled,
}: PhoneFieldProps): JSX.Element => {
  return (
    <PhoneFieldWrapper>
      <PhoneInput
        defaultCountry="ca"
        value={value}
        onChange={phone => onChange(phone)}
        disabled={disabled}
        inputProps={{ id: inputId, autoComplete: 'tel' }}
      />
    </PhoneFieldWrapper>
  )
}

export default PhoneField
